import { Box, Button, Image, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { trackSlide } from "areas/product/store/actions"
import { openModal } from "components/modal"

const UploadBtn = styled(Button).attrs({
  variant: "primary",
})`
  align-items: baseline;
  border-radius: 22px;
  display: inline-flex;
  font-size: 16px;
  font-weight: 700;
  height: 44px;
  line-height: 21px;
  padding: 12px 30px;
  ${(props) => props.theme.mediaQueries.tablet`
    font-weight: 300;
  `}
`
const InternalImageUploadBtn = ({
  handwritingEngraving,
  displayBtn,
  imageUploaded,
  openImageUploadModal,
}) => {
  const imgText = handwritingEngraving ? "Image" : "Photo"
  return (
    <Box textAlign="center">
      <UploadBtn
        data-cy="product-image-wizard-option-btn"
        display={displayBtn}
        onClick={() => {
          openImageUploadModal()
        }}
      >
        <Image
          alt={imageUploaded ? `Change ${imgText}` : `Upload ${imgText}`}
          mr={1}
          ratio="1 / 1"
          src={require("images/icons/upload-arrow.svg")}
          width="14px"
        />
        {imageUploaded ? `Change ${imgText}` : `Upload ${imgText}`}
      </UploadBtn>
      <Typography
        fontSize="12px"
        fontWeight="700"
        letterSpacing="-0.02em"
        lineHeight="14px"
        maxWidth="240px"
        mt="12px"
        mx="auto"
      >
        Photo or image uploads that include inappropriate, explicit, or illegal
        content will not be accepted.
      </Typography>
    </Box>
  )
}

InternalImageUploadBtn.propTypes = {
  displayBtn: PropTypes.object,
  handwritingEngraving: PropTypes.bool,
  imageUploaded: PropTypes.bool,
  openImageUploadModal: PropTypes.func,
  pref: PropTypes.string,
  toggleUploadModal: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  const pref = ownProps.pref || "img1"
  return {
    handwritingEngraving: state.wizard.data[pref]?.handwriting_engraving,
    image: state.display[pref],
    imageUploaded: state.choices[pref] && state.choices[pref].photoUploaded,
    wizardData: state.wizard.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { wizardData } = stateProps
  const { dispatch } = dispatchProps
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    openImageUploadModal: () => {
      const pref = ownProps.pref || "img1"
      const iwo = wizardData[pref]
      if (iwo?.track_slide) {
        dispatch(trackSlide(iwo.track_slide))
      }
      openModal(`#pendant-upload-${pref}`)
    },
  }
}

const ImageUploadBtn = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalImageUploadBtn)

export default ImageUploadBtn
